import app from '@/app.js'
import { component } from 'picoapp'
import { zelektor } from '@/lib/utility-functions.js'

export default component((node, ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { accept, decline } = zelektor(node)


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    node.addEventListener('click', e => {
        if (e.target === node) close()
    })
    
    ctx.on('cartTermsPopup:open', () => {
        open()
    })

    accept.addEventListener('click', () => {
        ctx.emit('cartTerms:accepted')
    })

    decline.addEventListener('click', () => {
        close()
    })

    
    /*******************************************************************************************************************************************/
    /* Open Popup
    /*******************************************************************************************************************************************/
    function open() {
        node.classList.add('is-open')
    }


    /*******************************************************************************************************************************************/
    /* Close Popup
    /*******************************************************************************************************************************************/
    function close() {
        node.classList.remove('is-open')
    }
})